module.exports = __webpack_public_path__ + "static/img/line.aab68cb8.svg";